export default __webpack_public_path__ + "static/media/elumnt1155.77cf6617.sol";